export class AtlUserNotificationsMenuToggleEvent extends Event {
  static EVENT_NAME = "atlantis-user-notifications-menu-toggle";

  constructor() {
    super(AtlUserNotificationsMenuToggleEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}

export class AtlUserNotificationsMenuCloseEvent extends Event {
  static EVENT_NAME = "atlantis-user-notifications-close";

  constructor() {
    super(AtlUserNotificationsMenuCloseEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}

export class AtlUserNotificationsArticleActionEvent extends Event {
  static EVENT_NAME = "atlantis-user-notifications-article-action";

  constructor() {
    super(AtlUserNotificationsArticleActionEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}

export class AtlUserProfileMenuToggleEvent extends Event {
  static EVENT_NAME = "atlantis-user-profile-menu-toggle";

  constructor() {
    super(AtlUserProfileMenuToggleEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}

export class AtlUserProfileMenuItemClickEvent extends Event {
  static EVENT_NAME = "atlantis-user-profile-menu-item-click";

  constructor() {
    super(AtlUserProfileMenuItemClickEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}
